/**
 * Formats a number as currency using Intl.NumberFormat
 * @param {number} value - The number to format
 * @param {Object} options - Currency formatting options
 * @param {number} [options.decimals=2] - Maximum decimal places
 * @param {string} [options.notation="standard"] - Notation style
 * @returns {string} Formatted currency string
 */
const _toCurrency = (value, options) => {
	const { decimals = 0, notation = "standard" } = options;

	return new Intl.NumberFormat("en-us", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
		useGrouping: true,
		notation
	}).format(value);
};

/**
 * Formats a number using Intl.NumberFormat
 * @param {number} value - The number to format
 * @param {Object} [options={}] - Number formatting options
 * @param {number} [options.decimals=0] - Minimum decimal places
 * @param {string} [options.notation="standard"] - Notation style
 * @returns {string} Formatted number string
 */
const _toDecimal = (value, options = {}) => {
	const { decimals = 0, notation = "standard" } = options;

	return new Intl.NumberFormat("en-us", {
		style: "decimal",
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
		useGrouping: true,
		notation
	}).format(value);
};

/**
 * Formats a number as percentage using Intl.NumberFormat
 * @param {number} value - The number to format (0.15 for 15% or 15 for 15% depending on multiplyBy100)
 * @param {Object} [options={}] - Percentage formatting options
 * @param {number} [options.decimals=0] - Minimum decimal places
 * @param {string} [options.notation="standard"] - Notation style
 * @returns {string} Formatted percentage string
 */
const _toPercentage = (value, options = {}) => {
	const { decimals = 0, notation = "standard" } = options;

	return new Intl.NumberFormat("en-us", {
		style: "percent",
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
		useGrouping: true,
		notation
	}).format(value);
};

/**
 * Universal format function that can format numbers as currency, number, or percentage
 * @param {number} value - The number to format
 * @param {"currency"|"number"|"percentage"} type - The format type
 * @param {Object} [options={}] - Type-specific formatting options
 * @returns {string} Formatted string
 */
const format = (value, type, options = {}) => {
	switch (type) {
		case "currency":
			return _toCurrency(value, options);
		case "number":
			return _toDecimal(value, options);
		case "percentage":
			return _toPercentage(value, options);
		default:
			throw new Error(`Unsupported format type: ${type}`);
	}
};

const pad = (v, size = 2) => v.toString().padStart(size, "0");


const toPhone = (v) => {
	if (!v) return "";
	const digits = v.replace(/\D/g, "").slice(0, 10);
	const lenght = digits.length;
	if (lenght === 0) return "";
	if (lenght < 4) return `(${digits}`;
	if (lenght < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
	return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export default {
	format,
	pad,
	toPhone
};